import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=4b1ada6a&scoped=true"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=4b1ada6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ada6a",
  null
  
)

export default component.exports